import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container text-center">
        <p>&copy; 2024-2025 LogiSim Team Project</p>
        <small>Built with React and Python for logistics optimization</small>
      </div>
    </footer>
  );
}

export default Footer;